<template>
  <b-form-select v-model="local_value" :options="options"></b-form-select>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { mapActions } from "vuex";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    options: [],
  }),
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions("oportunidades", ["ActionGetTiposInstrumentos"]),
  },
  async created() {
    let options = await this.ActionGetTiposInstrumentos();

    this.options = [
      {
        value: null,
        text: "Selecione um tipo de instrumento",
      },
      ...options,
    ];
  },
};
</script>
